import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  siteId: "", //selected site ID
  tenantId: "", //selected tenant ID
  sites: [], //list of sites for the selected tenant
};

/**
 * Parse JSON values within a site object, using default values
 * if there is a parsing error.
 * @param {dict} site object
 */
function parseJson(site) {
  // For the json attributes in the site database, convert them to javascript
  // objects. Some of them could be missing completely. So if the desired javascript
  // object does not exist, try to parse json. For any error, fill in default values.
  try {
    if (typeof site.alarmThresholds.wifi === "undefined") {
      site.alarmThresholds = JSON.parse(site.alarmThresholds);
    }
  } catch (e) {
    site.alarmThresholds = {
      // set default value
      wifi: {},
    };
  }

  try {
    if (typeof site.restrict_ui_page.inspection === "undefined") {
      site.restrict_ui_page = JSON.parse(site.restrict_ui_page);
    }
  } catch (e) {
    site.restrict_ui_page = {
      // set default value
      inspection: false,
      reception: false,
      security_patrol: false,
    };
  }

  try {
    if (typeof site.include_tags_in_round.inspection_patrol === "undefined") {
      site.include_tags_in_round = JSON.parse(site.include_tags_in_round);
    }
  } catch (e) {
    site.include_tags_in_round = {
      // set default value
      inspection_patrol: false,
      meetingroom_patrol: false,
      meetingroom_inspection: false,
    };
  }
}

function validateSite(site) {
  parseJson(site);
  if (!site.timezone) site.timezone = "America/New_York";
  site.allow_image_store = site.allow_image_store === true;
  site.allow_securityRound_tpapp = site.allow_securityRound_tpapp === true;
  // There could be old valid values for temperature/humidity.
  // Ensure we always have a wifi value, with default empty
  // meaning alert is disabled.
  if (typeof site.alarmThresholds.wifi === "undefined") {
    site.alarmThresholds.wifi = {};
  }
  if (!site.door_detect_locations) site.door_detect_locations = [];
  if (!site.display_detect_locations) site.display_detect_locations = [];
}

const siteSlice = createSlice({
  name: "site",
  initialState,
  reducers: {
    setTenant: (state, action) => {
      // if the tenant changes, the site list is invalidated
      if (state.tenantId !== action.payload) {
        state.siteId = "";
        state.sites = [];
        state.tenantId = action.payload;
      }
    },
    setSites: (state, action) => {
      state.sites = action.payload;
      for (const site of state.sites) {
        validateSite(site);
      }
    },
    setSiteId: (state, action) => {
      state.siteId = action.payload;
    },
    updateSite: (state, action) => {
      // update the fields included in payload
      const site = state.sites.find((s) => s.id === action.payload.id);
      Object.assign(site, action.payload);
      validateSite(site);
    },
  },
});

export const selectSite = (state) => {
  state = state.selectedSite; // get the site slice from the global state
  const selectedSite = state.sites.find((s) => s.id === state.siteId);
  return selectedSite;
};

export const { setTenant, setSites, setSiteId, updateSite } = siteSlice.actions;
export default siteSlice.reducer;
